import './ProductPage.css';
import { useParams, Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import MarkdownSpan from "../MarkdownSpan/MarkdownSpan";
import { Helmet } from 'react-helmet';

export default function ProductPage({ getProduct, data, cart, handleAddToCart, handlePlusToCart, handleMinusFromCart, getCategory, categoryData }) {
    const { productId } = useParams();

    const isInCart = !!cart.length && !!data && !!cart.find((item) => item.metadata.uid === data.metadata.uid);
    const quantity = isInCart ? cart.find((item) => item.metadata.uid === data.metadata.uid).quantity : 0;

    const [underCategory, setUnderCategory] = useState(null);
    const [mainCategory, setMainCategory] = useState(null);

    useEffect(() => {
        getProduct(productId);
    }, [productId]);

    useEffect(() => {
        if (data?.categoryUid) {
            getCategory(data.categoryUid).then((underCat) => {
                setUnderCategory(underCat);

                if (underCat?.parentCategoryUid) {
                    getCategory(underCat.parentCategoryUid).then((mainCat) => {
                        setMainCategory(mainCat);
                    });
                }
            });
        }
    }, [data]);

    if (!data) return null;

    function breadcrumb() {
        if (!underCategory || !mainCategory) return null;

        return (
            <div className="breadcrumbs-wrapper">
                <div className="breadcrumbs-track">
                    <Link className='breadcrumbLink' to="/">Главная</Link> /{' '}
                    <Link className='breadcrumbLink' to="/Catalog">Каталог</Link> /{' '}
                    <Link className='breadcrumbLink' to={`/Catalog/${mainCategory.metadata.uid}`}>{mainCategory.name}</Link> /{' '}
                    <Link className='breadcrumbLink' to={`/Catalog/${mainCategory.metadata.uid}#${underCategory.metadata.uid}`}>{underCategory.name}</Link>
                </div>
            </div>
        );
    }

    return (
        <section id='productPage'>
            <Helmet>
                <title>{data.name} - купить по выгодной цене - «Экопром-Строй»</title>
                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "Product",
                        "name": data.name,
                        "image": data.previewImage,
                        "description": data.description,
                        "sku": data.metadata?.uid,
                        "brand": {
                            "@type": "Brand",
                            "name": "Экопром"
                        },
                        "offers": {
                            "@type": "Offer",
                            "priceCurrency": "RUB",
                            "price": data.price,
                            "availability": "https://schema.org/InStock",
                            "url": window.location.href
                        }
                    })}
                </script> 
                </Helmet>
                <div className="productPage">
                    {breadcrumb()}
                    <div className='productHeader'>
                        <h1 className="productName">{data.name}</h1>
                        <div className="buttonPriceBox">
                            <p className='product-price'>{data.price} &#8381;</p>
                            {!isInCart && <button id='buttonAdd' onClick={() => handleAddToCart(data)} className='productButton'>В корзину</button>}
                            {isInCart && <div className='buttonAddBox'>
                                <button disabled id='buttonAdd' onClick={() => handleAddToCart(data)} className='productButton productButtonMarginRight'>Добавлено</button>
                                <div className='cartItemCount'>
                                    <button onClick={() => handleMinusFromCart(data)}>-</button>
                                    <p>{quantity}</p>
                                    <button onClick={() => handlePlusToCart(data)}>+</button>
                                </div>
                            </div>}
                        </div>
                    </div>

                    <div className='productBody'>
                        <div className='productImageBox'>
                            <img src={data.previewImage} alt={data.name} className='productImage' />
                        </div>

                        <div className='productDescription'>
                            <div >
                                <p><MarkdownSpan markdownText={data?.description ? data.description : ''} /></p>
                            </div>

                            <div className="productTableBox">
                                <table className="productTable">
                                    <tbody>
                                        {Object.entries(data.characteristics).map(([key, value]) => (
                                            <tr key={key} className="tableTr">
                                                <td className="tableTd">{key}:</td><td className="tableTd">{value}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>


                </div>
        </section>
    )
}
